import {
  getPostApiV1ThreeLetterCodePartnerAdminsGroupsMutationFetcher,
  getPostApiV1ThreeLetterCodePartnerAdminsGroupsMutationKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import { PostApiV1ThreeLetterCodePartnerAdminsGroups201 } from '@fukuri-admins/apis/client/gen/model';
import { useMutation } from '@fukuri-admins/hooks/common';
import { AxiosError } from 'axios';

/**
 * グループ作成APIを実行するカスタムフック
 *
 * @param threeLetterCode - パートナーコード
 * @param options - コールバックオプション
 * @param options.onSuccess - 成功時のコールバック
 * @param options.onError - エラー時のコールバック
 */
export const usePostPartnerAdminsGroups = (
  threeLetterCode: string,
  options?: {
    onSuccess?: (data: PostApiV1ThreeLetterCodePartnerAdminsGroups201) => void;
    onError?: (error: AxiosError<{ errors?: string[] }>) => void;
  }
) => {
  return useMutation(
    getPostApiV1ThreeLetterCodePartnerAdminsGroupsMutationKey(threeLetterCode),
    getPostApiV1ThreeLetterCodePartnerAdminsGroupsMutationFetcher(threeLetterCode),
    options
  );
};
